import { clearIqSetupContext } from './iq-setup-context.helper';

const EXPLICIT_LOGOUT_SESSION_KEY = 'daton_explicit_logout';

/**
 * Marks that the user intentionally signed out of Daton (not a global SSO switch). Also drops
 * the iQ setup context, so the next sign-in in this tab is not sent back into iQ setup.
 */
export function markExplicitLogout(): void {
  try {
    sessionStorage.setItem(EXPLICIT_LOGOUT_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
  clearIqSetupContext();
}

/** Returns true when an intentional Daton sign-out marker is present in sessionStorage. */
export function isExplicitLogoutPending(): boolean {
  try {
    return sessionStorage.getItem(EXPLICIT_LOGOUT_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

/** Clears the intentional Daton sign-out marker from sessionStorage. */
export function clearExplicitLogout(): void {
  try {
    sessionStorage.removeItem(EXPLICIT_LOGOUT_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
